import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { initEditTitle } from "../shared/edit_title.js";

const scan = (container) => initEditTitle(container);

onViewLoad("shipments#show", () => {
  scan(document);
  document.addEventListener("partial:replace", (ev) => scan(ev.container));
});
